var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ms-3" },
    _vm._l(_vm.optionsAll, function (option, idx) {
      return _c(
        "div",
        {
          key: idx,
          class: [
            _vm.outerClass,
            _vm.radioSelected == option.id ? "selected" : "",
          ],
          staticStyle: { position: "relative" },
        },
        [
          _c(
            "div",
            {
              staticClass: "radio radio-custom",
              class: { disabled: option.disabled },
              attrs: {
                title: option.disabled ? "opcja chwilowo niedostępna" : "",
              },
            },
            [
              _c(
                "label",
                { class: _vm.innerClass, attrs: { for: _vm.id + "-" + idx } },
                [
                  option.icon ? _c("div", { class: option.icon }) : _vm._e(),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.radioSelected,
                        expression: "radioSelected",
                      },
                    ],
                    attrs: {
                      name: _vm.id,
                      id: _vm.id + "-" + idx,
                      type: "radio",
                      disabled: option.disabled,
                    },
                    domProps: {
                      value: option.id,
                      checked: _vm._q(_vm.radioSelected, option.id),
                    },
                    on: {
                      change: function ($event) {
                        _vm.radioSelected = option.id
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "radio-custom-btn" }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "option-text",
                    domProps: { innerHTML: _vm._s(option.name) },
                  }),
                  _vm._v(" "),
                  _vm.aria ? _c("span", [_vm._v(_vm._s(_vm.aria))]) : _vm._e(),
                ]
              ),
            ]
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }